import React, { useEffect, useState } from 'react'
import { Modal } from '@intelie/ui'
import i18n from 'live/services/i18n'
import styled from 'styled-components'
import { PackageFeatureResource } from '../http/api'

type Props = {
    isOpen: boolean
    isEnabled: boolean
    feature: PackageFeatureResource
    callbackConfirm(confirmed: boolean): void
}

const getTitle = enabled => i18n(enabled ? 'Enable' : 'Disable')
const getMessage = (enabled, label) => {
    if (enabled) {
        return (
            <Msg id="modal-msg-enable">
                <span>
                    {i18n('You are trying to enable the feature')} <b>{label}.</b>
                </span>
                <span>{i18n('Are you sure you want to proceed with this action')}?</span>
            </Msg>
        )
    } else {
        return (
            <Msg id="modal-msg-disable">
                <span>
                    {i18n('You are trying to disable the feature')} <b>{label}.</b>{' '}
                    {i18n('This will prevent users from accessing the feature')}.
                </span>
                <span>{i18n('Are you sure you want to proceed with this action')}?</span>
            </Msg>
        )
    }
}

const ModalActivationFeature = ({ isOpen, isEnabled = false, feature, callbackConfirm }: Props) => {
    const [title, setTitle] = useState<string>(getTitle(isEnabled))
    const label = feature.label || feature.name

    useEffect(() => {
        setTitle(getTitle(isEnabled))
    }, [isEnabled])

    return (
        <Modal
            show={isOpen}
            closable={true}
            size="390px"
            onHide={() => {
                callbackConfirm(false)                
            }}
            onSave={() =>
                new Promise<void>(resolve => {
                    callbackConfirm(true)
                    resolve()
                })
            }
        >
            <Modal.Header
                closeButton={true}
                title={
                    <ModalTitle>
                        <i className="far fa-exclamation-triangle" />
                        {title}
                    </ModalTitle>
                }                
            />
            <Modal.Content>{getMessage(isEnabled, label)}</Modal.Content>
            <Modal.Footer saveLabel={title} hideLabel={i18n('Cancel')}/>
        </Modal>
    )
}

export default ModalActivationFeature

const ModalTitle = styled.span`
    font-size: 18px;
    color: ${({ theme }) => theme['gray-800']};

    i {
        margin-right: 12px;
        color: ${({ theme }) => theme['yellow-700']};
    }
`

const Msg = styled.div`
    span {
        font-size: 13px;
        color: ${({ theme }) => theme['gray-800']};

        &:first-child {
            display: block;
            margin-bottom: 16px;
        }
    }
`
